<template>
   <el-dialog
   v-loading="imgLoading"
   class="wrap"
  :visible.sync="dialogVisible"
  element-loading-background="rgba(0, 0, 0, 0.8)"
  :show-close="false"
  title="请使用微信扫描"
  :before-close="handleClose">
  <img :src="qrCodeUrl" alt="" class="code">
  <div class="desc">查看直播详细信息</div>
</el-dialog>
</template>
<script>
import { getWcWeb, authAddString } from '@/api/wc_web'
export default {
  data () {
    return {
      dialogVisible: false,
      qrCodeUrl: '',
      imgLoading: false
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    async init (val) {
      this.qrCodeUrl = ''
      this.imgLoading = true
      const obj1 = {
        name: 'webapi.auth.addstring',
        data: {
          // stringUrl: val.id
          stringUrl: JSON.stringify({
            id: val.id,
            faOutId: this.$route.query.outId ? this.$route.query.outId : ''
          })
        }
      }
      const res = await authAddString(obj1)
      const obj2 = {
        name: 'wechat.wxacode',
        data: {
          sourceCode: 'wbs_investor',
          scene: res.value,
          width: '1',
          auto_color: false,
          line_color: '',
          is_hyaline: false,
          page: 'pages/liveMarketing/liveMarketing'
        }
      }
      const res2 = await getWcWeb(obj2)
      this.imgLoading = false
      if (res2.code === 0) {
        const str = 'data:image/png;base64,' + res2.value
        this.qrCodeUrl = str
      } else {
        this.dialogVisible = false
        this.$showError(res2.msg)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap ::v-deep .el-dialog__header{
  padding:24px 0 0 0;
  text-align:center;
}
.wrap ::v-deep .el-dialog__body{
  padding:0;
  margin:0;
  text-align:center;
}
.wrap ::v-deep .el-dialog{
  width:276px;
}
.code {
  width: 180px;
  height:180px;
  margin: 34px 48px;
  background: #ffffff;
}
.desc{
  width:100%;
  padding:12px 0;
  background: #187fc3;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color:#fff;
  text-align:center;
}
</style>
